import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

document.addEventListener('DOMContentLoaded', function() {
    // 获取所有导航链接和章节
    const sections = document.querySelectorAll('.section');
    const progressDots = document.querySelectorAll('.progress-dot');
    
    // 设置Intersection Observer来检测章节进入视口
    const observerOptions = {
        root: null,
        rootMargin: '120px',
        threshold: 0.6
    };
    
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // 获取当前可见章节的ID
                const currentSectionId = entry.target.id;
                
                // 为对应导航链接添加active类
                const correspondingNavLink = document.querySelector(`.nav-link[href="#${currentSectionId}"]`);
                if (correspondingNavLink) {
                    correspondingNavLink.classList.add('active');
                }
                
                // 更新进度指示器
                progressDots.forEach(dot => {
                    dot.classList.remove('active');
                    if (dot.dataset.section === currentSectionId) {
                        dot.classList.add('active');
                    }
                });
                
                // 更新章节的active状态
                sections.forEach(section => {
                    section.classList.remove('active');
                });
                entry.target.classList.add('active');
            }
        });
    }, observerOptions);
    
    // 开始观察每个章节
    sections.forEach(section => {
        observer.observe(section);
    });
    
    // 为进度指示器添加点击事件
    progressDots.forEach(dot => {
        dot.addEventListener('click', function() {
            const sectionId = this.dataset.section;
            const targetSection = document.getElementById(sectionId);
            
            if (targetSection) {
                targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
    
});

var news_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.news ul li:not(:first) .text').each(function() { //遍历相同样式名的元素
    var news = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    news_max = news > news_max ? news : news_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.news ul li:not(:first) .text').height(news_max); //给每一个元素设置相同的高度	 


var blogSwiper = new Swiper(".blog .swiper", {
    breakpoints: {
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 3.29,
            spaceBetween: 24,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 1,
            spaceBetween: 10, 
        }
    }  
}); 

var blog_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.blog .swiper .swiper-slide .text').each(function() { //遍历相同样式名的元素
    var blog = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    blog_max = blog > blog_max ? blog : blog_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.blog .swiper .swiper-slide .text').height(blog_max); //给每一个元素设置相同的高度	

var video_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.video ul li .text').each(function() { //遍历相同样式名的元素
    var video = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    video_max = video > video_max ? video : video_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.video ul li .text').height(video_max); //给每一个元素设置相同的高度

var project_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.project ul li .text').each(function() { //遍历相同样式名的元素
    var project = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    project_max = project > project_max ? project : project_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.project ul li .text').height(project_max); //给每一个元素设置相同的高度	